import { SharedDataprivacyApi } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useMemo } from 'react';

import { useApiConfiguration } from '@/features/api/hooks/useApiConfiguration';

export const useSharedDataPrivacyApi = () => {
  const configuration = useApiConfiguration();
  return useMemo(
    () => new SharedDataprivacyApi(configuration),
    [configuration]
  );
};
